<script>
import { get } from "lodash";
import { mapState } from "vuex";
import api from "@/services/api";

const MESSAGE_BY_STATUS = {
  200: "Obrigado por responder o e-mail e nos ajudar!",
  404: "Não encontramos a indicação que você está procurando.",
  406: "Sua indicação já foi confirmada.",
  409: "Você já sugeriu essa indicação.",
}

export default {
  name: "confirmation",
  data: () => ({
    query: null,
    message: "Olá, estamos processando sua solicitação.",
  }),
  computed: {
    ...mapState("company", ["company"]),

    logo() {
      return this.company && this.company.logo_url ? this.company.logo_url : 'https://d2bxzineatl84k.cloudfront.net/storage/files/logos/uAytbGSN4Z0Pv87VpYst62z4aOSoIgl1Fb0JtU2h.png';
    }
  },
  methods: {
    async fetchWhiteLabelCompany() {
      try {
        this.$vs.loading();
        const { params } = this.$router.history.current;

        const response = await api.get(`api/v1/talent/${params.company_label}`);

        const { data } = response.data;

        if (data) {
          this.$store.commit("company/SET_COMPANY", data);
        }

        if (this.company) {
          this.updatePrimaryColor();
          this.$vs.loading.close();
          this.isLoading = false;
        }
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    async fetchStatusIndication() {
      try {
        this.$vs.loading();

        const query = get(this.$router, "history.current.query", null);
        if (query) {
          const { type, token, action } = query;

          if (type === "indications" && token && action) {
            //TODO: Remover o ?debug=true antes de subir para produção
            const response = await api.put(`api/v1/${type}/${token}/${action}?debug=true`);
            const status = get(response, "status", 0);
            this.message = MESSAGE_BY_STATUS[status];
          }
        }
        this.$vs.loading.close();
      } catch (error) {
        const status = get(error, "response.status", 0);
        this.message = MESSAGE_BY_STATUS[status];
        this.$vs.loading.close();
      }      
    },
    updatePrimaryColor() {
      if (
        this.company &&
        this.company.hasOwnProperty("base_hexcolor") &&
        this.company.base_hexcolor !== ""
      ) {
        this.$vs.theme({ primary: this.company.base_hexcolor });
      }
    },
  },
  created() {
    this.fetchWhiteLabelCompany();
    this.fetchStatusIndication();
  },
};
</script>

<template>
  <div class="confirmation">
    <img alt="logo da empresa" :src="logo"/>
    <h1>🌟 Obrigado pela confirmação! 🌟</h1>
    <p>{{ message }}</p>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="209"
      height="187"
      viewBox="0 0 209 187"
      fill="none"
    >
      <g clip-path="url(#clip0_3829_5366)">
        <path
          d="M206.675 71.5126C206.601 71.5126 206.528 71.4898 206.467 71.4471L105.547 1.05696C105.24 0.843751 104.875 0.729806 104.501 0.730444C104.128 0.731082 103.763 0.846272 103.457 1.06053L3.26402 71.4464C3.18477 71.5021 3.08669 71.5239 2.99135 71.5072C2.89601 71.4904 2.81122 71.4364 2.75563 71.357C2.70005 71.2777 2.67822 71.1794 2.69495 71.0839C2.71168 70.9885 2.7656 70.9035 2.84485 70.8479L103.038 0.46201C103.467 0.16209 103.977 0.00086837 104.5 7.28209e-06C105.023 -0.000853806 105.534 0.158685 105.964 0.457192L206.884 70.8471C206.948 70.8916 206.996 70.9553 207.021 71.029C207.046 71.1027 207.047 71.1824 207.024 71.2566C207 71.3309 206.954 71.3957 206.891 71.4418C206.829 71.4878 206.753 71.5126 206.675 71.5126Z"
          fill="#172B4D"
        />
        <path
          d="M8.98926 74.0077L104.601 3.04031L200.938 79.0573L109.527 133.329L59.8989 122L8.98926 74.0077Z"
          fill="#97A0AF"
        />
        <path
          d="M64.088 166.85H16.8536C16.5636 166.851 16.2763 166.794 16.0083 166.683C15.7402 166.572 15.4966 166.409 15.2914 166.204C15.0862 165.999 14.9234 165.755 14.8123 165.487C14.7012 165.218 14.644 164.931 14.644 164.64C14.644 164.35 14.7012 164.062 14.8123 163.794C14.9234 163.526 15.0862 163.282 15.2914 163.077C15.4966 162.871 15.7402 162.709 16.0083 162.598C16.2763 162.487 16.5636 162.43 16.8536 162.43H64.088C64.378 162.43 64.6653 162.487 64.9334 162.598C65.2014 162.709 65.445 162.871 65.6502 163.077C65.8555 163.282 66.0183 163.526 66.1294 163.794C66.2404 164.062 66.2976 164.35 66.2976 164.64C66.2976 164.931 66.2404 165.218 66.1294 165.487C66.0183 165.755 65.8555 165.999 65.6502 166.204C65.445 166.409 65.2014 166.572 64.9334 166.683C64.6653 166.794 64.378 166.851 64.088 166.85Z"
          fill="#AA50A1"
        />
        <path
          d="M33.8003 157.348H16.8536C16.5636 157.349 16.2763 157.292 16.0083 157.181C15.7402 157.07 15.4966 156.907 15.2914 156.702C15.0862 156.497 14.9234 156.253 14.8123 155.985C14.7012 155.716 14.644 155.429 14.644 155.138C14.644 154.848 14.7012 154.56 14.8123 154.292C14.9234 154.023 15.0862 153.78 15.2914 153.574C15.4966 153.369 15.7402 153.206 16.0083 153.096C16.2763 152.985 16.5636 152.928 16.8536 152.928H33.8003C34.0903 152.928 34.3776 152.985 34.6456 153.096C34.9137 153.206 35.1573 153.369 35.3625 153.574C35.5677 153.78 35.7306 154.023 35.8416 154.292C35.9527 154.56 36.0099 154.848 36.0099 155.138C36.0099 155.429 35.9527 155.716 35.8416 155.985C35.7306 156.253 35.5677 156.497 35.3625 156.702C35.1573 156.907 34.9137 157.07 34.6456 157.181C34.3776 157.292 34.0903 157.349 33.8003 157.348Z"
          fill="#AA50A1"
        />
        <path
          d="M105.945 113.536C105.586 113.536 105.23 113.466 104.898 113.33L45.9316 88.8261V12.1242C45.9324 11.446 46.2018 10.7957 46.6807 10.3161C47.1595 9.83653 47.8088 9.56675 48.486 9.56596H161.609C162.286 9.56675 162.935 9.83653 163.414 10.3161C163.893 10.7957 164.162 11.446 164.163 12.1242V88.8797L164.052 88.9271L107.024 113.318C106.682 113.462 106.316 113.536 105.945 113.536Z"
          fill="white"
        />
        <path
          d="M105.945 113.718C105.562 113.719 105.183 113.644 104.828 113.499L45.749 88.9482V12.1242C45.7498 11.3975 46.0385 10.7008 46.5515 10.1869C47.0646 9.67308 47.7603 9.38403 48.4859 9.38321H161.609C162.334 9.38403 163.03 9.67308 163.543 10.1869C164.056 10.7008 164.345 11.3975 164.345 12.1242V89.0003L107.095 113.486C106.731 113.64 106.34 113.719 105.945 113.718ZM46.4788 88.46L105.107 112.824C105.654 113.046 106.266 113.042 106.81 112.813L163.616 88.5178V12.1242C163.615 11.5913 163.403 11.0804 163.027 10.7036C162.651 10.3268 162.141 10.1148 161.609 10.1141H48.4859C47.9538 10.1148 47.4437 10.3268 47.0674 10.7036C46.6911 11.0804 46.4795 11.5913 46.4789 12.1242L46.4788 88.46Z"
          fill="#172B4D"
        />
        <path
          d="M205.946 70.7816H205.873L163.981 88.6968L106.664 113.209C106.44 113.303 106.2 113.352 105.957 113.353C105.714 113.355 105.473 113.308 105.248 113.216L46.114 88.6456L3.19301 70.8109L3.12744 70.7816H3.05439C2.37715 70.7824 1.72787 71.0522 1.24899 71.5318C0.770113 72.0114 0.500751 72.6616 0.5 73.3399V184.442C0.500752 185.12 0.770113 185.77 1.24899 186.25C1.72787 186.729 2.37715 186.999 3.05439 187H205.946C206.623 186.999 207.272 186.729 207.751 186.25C208.23 185.77 208.499 185.12 208.5 184.442V73.3399C208.499 72.6616 208.23 72.0114 207.751 71.5318C207.272 71.0522 206.623 70.7824 205.946 70.7816ZM207.77 184.442C207.77 184.926 207.578 185.391 207.236 185.734C206.893 186.076 206.429 186.269 205.946 186.269H3.05439C2.57054 186.269 2.10657 186.076 1.76444 185.734C1.42231 185.391 1.23002 184.926 1.22982 184.442V73.3399C1.23049 72.8674 1.41351 72.4134 1.74062 72.0728C2.06774 71.7323 2.51362 71.5315 2.98507 71.5126L46.114 89.435L104.967 113.892C105.604 114.152 106.318 114.148 106.952 113.881L163.981 89.4899L206.019 71.5126C206.489 71.5329 206.934 71.7342 207.26 72.0746C207.586 72.4149 207.769 72.8681 207.77 73.3399V184.442Z"
          fill="#172B4D"
        />
        <path
          d="M105.356 91.7858C103.179 91.7899 101.06 91.0849 99.3181 89.7772L99.2102 89.696L76.4721 72.2605C75.4191 71.4524 74.5353 70.4445 73.8711 69.2944C73.207 68.1442 72.7756 66.8743 72.6015 65.5572C72.4274 64.24 72.5141 62.9014 72.8565 61.6178C73.199 60.3342 73.7905 59.1308 74.5974 58.0761C75.4042 57.0215 76.4106 56.1363 77.559 55.4712C78.7074 54.8061 79.9754 54.374 81.2905 54.1996C82.6056 54.0253 83.9422 54.1121 85.2238 54.455C86.5055 54.798 87.7072 55.3904 88.7602 56.1985L103.488 67.5089L138.293 22.0497C139.1 20.9953 140.107 20.1105 141.255 19.4458C142.404 18.781 143.672 18.3494 144.987 18.1755C146.302 18.0017 147.639 18.0889 148.921 18.4324C150.202 18.7758 151.403 19.3687 152.456 20.1772L152.24 20.4715L152.462 20.1815C154.585 21.8161 155.975 24.2275 156.325 26.8868C156.676 29.5461 155.959 32.2361 154.331 34.3665L113.393 87.8374C112.446 89.0696 111.229 90.0667 109.835 90.7514C108.441 91.4362 106.908 91.7901 105.356 91.7858Z"
          fill="#AA50A1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3829_5366">
          <rect width="208" height="187" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.confirmation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 60px;
  height: 100vh;
  width: 100%;

  img {
    max-width: 200px;
    object-fit: contain;
  }
}
</style>
